/* 8bitbrain v10 shared behaviour.
   [data-h10-r]      reveal (blur + rise); optional data-h10-d="0.1" delay
   [data-h10-s]      stagger its children
   [data-h10-split]  split into words that rise out of a mask (keeps inner markup such as .h10-it)
   [data-h10-ring]   ring fills 0 -> --pt when visible, then flashes (.h10-done)
   [data-h10-count]  first number in the text counts up from 0 (keeps the rest of the text)
   [data-h10-spot]   section: sets --mx/--my for the spotlight grid background */
(function () {
  if (window.__h10) return; window.__h10 = 1;
  var RED = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function split(el) {
    if (el.__h10sp) return; el.__h10sp = 1;
    [].forEach.call(el.querySelectorAll('.h10-it,.h10-gt'), function (x) { x.classList.add('h10-sp'); });
    var n = 0, walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null), nodes = [], t;
    while ((t = walker.nextNode())) nodes.push(t);
    nodes.forEach(function (node) {
      var parts = node.nodeValue.split(/(\s+)/), frag = document.createDocumentFragment();
      parts.forEach(function (p) {
        if (!p) return;
        if (/^\s+$/.test(p)) { frag.appendChild(document.createTextNode(p)); return; }
        var w = document.createElement('span'), wi = document.createElement('span');
        w.className = 'h10-w'; wi.className = 'h10-wi'; wi.style.setProperty('--i', n++); wi.textContent = p; w.appendChild(wi); frag.appendChild(w);
      });
      node.parentNode.replaceChild(frag, node);
    });
  }

  function count(el) {
    if (el.__h10c) return; el.__h10c = 1;
    var txt = el.textContent, m = txt.match(/\d[\d,.]*/); if (!m || RED) return;
    var raw = m[0], target = parseFloat(raw.replace(/,/g, '')), comma = raw.indexOf(',') > -1, dec = (raw.split('.')[1] || '').length;
    if (!isFinite(target) || target === 0) return;
    var pre = txt.slice(0, m.index), post = txt.slice(m.index + raw.length), t0 = 0, dur = 1700;
    function fmt(v) { var s = v.toFixed(dec); if (comma) s = s.replace(/\B(?=(\d{3})+(?!\d))/g, ','); return s; }
    function step(ts) {
      if (!t0) t0 = ts; var k = Math.min(1, (ts - t0) / dur), e = 1 - Math.pow(1 - k, 3);
      el.textContent = pre + fmt(target * e) + post;
      if (k < 1) requestAnimationFrame(step);
    }
    el.textContent = pre + fmt(0) + post; requestAnimationFrame(step);
  }

  function enter(el) {
    el.classList.add('h10-in');
    if (el.hasAttribute('data-h10-ring')) {
      el.classList.add('h10-on');
      setTimeout(function () { el.classList.add('h10-done'); }, RED ? 0 : 1900);
    }
    [].forEach.call(el.querySelectorAll ? el.querySelectorAll('[data-h10-count]') : [], count);
    if (el.hasAttribute('data-h10-count')) count(el);
  }

  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { enter(e.target); io.unobserve(e.target); } });
  }, { threshold: .12, rootMargin: '0px 0px -8% 0px' }) : null;

  function scan() {
    [].forEach.call(document.querySelectorAll('[data-h10-split]'), split);
    [].forEach.call(document.querySelectorAll('[data-h10-s]'), function (c) {
      [].forEach.call(c.children, function (k, i) { k.style.setProperty('--i', i); });
    });
    [].forEach.call(document.querySelectorAll('[data-h10-r],[data-h10-s],[data-h10-split],[data-h10-ring]'), function (el) {
      if (el.__h10r) return; el.__h10r = 1;
      var d = el.getAttribute('data-h10-d'); if (d) el.style.transitionDelay = d + 's';
      if (!io) { enter(el); return; }
      io.observe(el);
    });
    [].forEach.call(document.querySelectorAll('[data-h10-spot]'), function (sec) {
      if (sec.__h10m || RED || !(window.matchMedia && matchMedia('(hover:hover)').matches)) return; sec.__h10m = 1;
      var raf = 0, x = 0, y = 0;
      sec.addEventListener('pointermove', function (e) {
        var r = sec.getBoundingClientRect(); x = e.clientX - r.left; y = e.clientY - r.top;
        if (!raf) raf = requestAnimationFrame(function () { raf = 0; sec.style.setProperty('--mx', x + 'px'); sec.style.setProperty('--my', y + 'px'); });
      }, { passive: true });
    });
  }
  /* pause looping background animations of sections that are off screen */
  var vio = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { e.target.classList.toggle('h10-off', !e.isIntersecting); });
  }, { rootMargin: '150px 0px' }) : null;
  function watch() { if (!vio) return; [].forEach.call(document.querySelectorAll('section.h10'), function (s) { if (s.__h10v) return; s.__h10v = 1; vio.observe(s); }); }
  var scan0 = scan; scan = function () { scan0(); watch(); };
  scan();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  document.addEventListener('shopify:section:load', scan);
  window.H10 = { scan: scan };
})();
